import React from "react";
import AboutMe from "../sections/AboutMe";
import Skills from "../sections/Skills";
import Experience from "../sections/Experience";
import Articles from "../sections/Articles";
import Certificate from "../sections/Certificate";

function Content(props) {
  return (
    <main>
      <AboutMe />
      <Skills />
      <Certificate />
      <Experience />
      <Articles/>
    </main>
  );
}

export default Content;
